'use strict';

module.exports = require('./lib/React');



//////////////////
// WEBPACK FOOTER
// /private/var/folders/n9/yczdnstj3wdc9q5tzm6d45c00000gp/T/maison-encans-auex-website/~/react/react.js
// module id = 1
// module chunks = 6